export function isValidTenantSubdomain(subdomain: string): boolean {
  const regex = /^[a-z0-9-]+$/;
  return regex.test(subdomain);
}
